import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_URL } from './../config/contants';
import { API_TOKEN } from './../config/contants';
import { LocalStorageProvider } from '../providers/local-storage';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class VinhosProvider {

  constructor(public http: HttpClient, public localStorage: LocalStorageProvider) {

  }

  vinhos      = []
  busca       : any
  categorias  : any
  results     : any

  getVinhos(refresh = false, categoria) {

    if(refresh) {
      this.vinhos = []
    }

    interface ItemsResponse {
      results: string[]
    }

    return new Promise((resolve, reject) => {
      this.http.get<ItemsResponse>(SERVER_URL + 'vinhos/vinhos_mobile?categoria=' + categoria, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            this.results = data;

            for (let dados of this.results) {
              this.vinhos.push(dados)
            };

            this.localStorage.storageSave('vinhos_' + categoria, this.vinhos)

            resolve(this.vinhos)
          },
          err => {
            reject(err)
          }
        )
    })
  }

  getCategorias() {

    interface ItemsResponse {
      categorias: string[]
    }

    return new Promise((resolve, reject) => {
      this.http.get<ItemsResponse>(SERVER_URL + 'vinhos/categorias', { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            this.categorias = data

            this.localStorage.storageSave('categorias_vinhos', this.categorias)

            resolve(this.categorias)
          },
          err => {
            reject(err)
          }
        )
    })
  }

  getVinhosClassificacao(classificacao) {
    return new Promise((resolve, reject) => {
      this.http.get(SERVER_URL + 'carta/classificacao?c=' + classificacao, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            this.localStorage.storageSave('vinhos_classificacao_' + classificacao, data)
            resolve(data)
          },
          err => {
            reject(err)
          }
        )
    })
  }

  getCartaVinhos(categoria, parametro = 'tipo_id') {
    return new Promise((resolve, reject) => {
      this.http.get(SERVER_URL + 'carta/vinhos?'+ parametro +'=' + categoria, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            this.localStorage.storageSave('vinhos_tipos_' + parametro + '_' + categoria, data['vinhos'])
            resolve(data['vinhos'])
          },
          err => {
            reject(err)
          }
        )
    })
  }

  getVinhosTipos() {
    return new Promise((resolve, reject) => {
      this.http.get(SERVER_URL + 'carta/tipos', { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            this.localStorage.storageSave('vinhos_tipos', data)
            resolve(data)
          },
          err => {
            reject(err)
          }
        )
    })
  }

  buscaVinhos(termo) {

    interface ItemsResponse {
      categorias: string[]
    }

    return new Promise((resolve, reject) => {
      this.http.get<ItemsResponse>(SERVER_URL + 'vinhos/vinhos_busca?q=' + termo, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {

            this.busca = data
            resolve(this.busca)
          },
          err => {
            reject(err)
          }
        )
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/vinhos.ts